import React, {
  useState,
} from 'react';

import {
  createPortal,
} from 'react-dom';

import {
  useTranslation,
} from 'react-i18next';

import {
  verifyCurrentPassword,
} from '../../services/profileService';

export default function PasswordVerificationModal({
  open,
  onClose,
  onVerified,
}) {
  const {
    t,
  } = useTranslation(
    'app',
  );

  const [
    currentPassword,
    setCurrentPassword,
  ] = useState(
    '',
  );

  const [
    passwordError,
    setPasswordError,
  ] = useState(
    '',
  );

  const [
    isVerifyingPassword,
    setIsVerifyingPassword,
  ] = useState(
    false,
  );

  if (!open) {
    return null;
  }

  const resetModal = () => {
    setCurrentPassword(
      '',
    );

    setPasswordError(
      '',
    );
  };

  const handleClose = () => {
    if (
      isVerifyingPassword
    ) {
      return;
    }

    resetModal();

    onClose?.();
  };

const handleVerifyPassword =
  async (
    event,
  ) => {
    event?.preventDefault?.();

    const password =
      String(
        currentPassword ||
        '',
      );

    if (
      !password
    ) {
      setPasswordError(
        t(
          'memberedit.passwordVerification.required',
        ),
      );

      return;
    }

    setIsVerifyingPassword(
      true,
    );

    setPasswordError(
      '',
    );

    try {
      const result =
        await verifyCurrentPassword(
          password,
        );

      if (
        result === false ||
        result?.verified === false ||
        result?.matched === false ||
        result?.success === false
      ) {
        setPasswordError(
          t(
            'memberedit.passwordVerification.mismatch',
          ),
        );

        return;
      }

      resetModal();

      onVerified?.();
    } catch (
      error
    ) {
      setPasswordError(
        t(
          'memberedit.passwordVerification.mismatch',
        ),
      );
    } finally {
      setIsVerifyingPassword(
        false,
      );
    }
  };

  return createPortal(
    <div
      role="presentation"
      onMouseDown={(
        event,
      ) => {
        if (
          event.target ===
          event.currentTarget
        ) {
          handleClose();
        }
      }}
      style={{
        position:
          'fixed',

        top:
          0,

        left:
          0,

        right:
          0,

        bottom:
          0,

        zIndex:
          100000,

        display:
          'flex',

        alignItems:
          'center',

        justifyContent:
          'center',

        padding:
          '24px',

        boxSizing:
          'border-box',

        background:
          'rgba(0, 0, 0, 0.48)',
      }}
    >
      <form
        className="memberInfo-password-dialog"
        onSubmit={
          handleVerifyPassword
        }
      >
        <div
          className="memberInfo-password-dialog-header"
        >
          <div>
            <h3>
              {t(
                'memberedit.passwordVerification.title',
              )}
            </h3>

            <p>
              {t(
                'memberedit.passwordVerification.description',
              )}
            </p>
          </div>

          <button
            type="button"
            className="memberInfo-password-dialog-close"
            onClick={
              handleClose
            }
            disabled={
              isVerifyingPassword
            }
          />
        </div>

        <div
          className="memberInfo-password-dialog-content"
        >
          <label
            htmlFor="memberInfo-current-password"
          >
            {t(
              'memberedit.passwordVerification.currentPassword',
            )}
          </label>

          <input
            id="memberInfo-current-password"
            type="password"
            value={
              currentPassword
            }
            onChange={(
              event,
            ) => {
              setCurrentPassword(
                event.target.value,
              );

              if (
                passwordError
              ) {
                setPasswordError(
                  '',
                );
              }
            }}
            autoComplete="current-password"
            autoFocus
            disabled={
              isVerifyingPassword
            }
          />

          {passwordError && (
            <div
              className="memberInfo-password-dialog-error"
            >
              {
                passwordError
              }
            </div>
          )}
        </div>

        <div
          className="memberInfo-password-dialog-footer"
        >
          <button
            type="button"
            className="memberInfo-cancel-button"
            onClick={
              handleClose
            }
            disabled={
              isVerifyingPassword
            }
          >
            {t(
              'common.cancel',
            )}
          </button>

          <button
            type="submit"
            className="memberInfo-save-button"
            disabled={
              isVerifyingPassword
            }
          >
            {isVerifyingPassword
              ? t(
                  'memberedit.passwordVerification.checking',
                )
              : t(
                  'memberedit.passwordVerification.confirm',
                )}
          </button>
        </div>
      </form>
    </div>,
    document.body,
  );
}